import { HttpService } from '@/data/http/http-service';

import {
  FeatureCollectionSchema,
  PhotonFeature,
  PhotonFeatureCollection,
} from './photon-api.dto';

const httpProject = new HttpService({
  baseURL: import.meta.env.VITE_API_PROJECT,
});

export async function fetchPhotonApi(
  query: string,
  limit: number = 6,
): Promise<PhotonFeature[]> {
  try {
    const url = 'geo-position/search-with-photon';
    const data = { query, limit };
    const options = { includeAuthorization: false };
    const response = await httpProject.post(url, data, options);
    const parsedData: PhotonFeatureCollection = FeatureCollectionSchema.parse(
      response.data,
    );
    const features: PhotonFeature[] = parsedData.features;
    return features;
  } catch (error) {
    console.error('error fetching photon api', error);
    return [];
  }
}
